{
  "backButton": "Povratak na {prevMenuButton}",
  "moreActions": "Dodatne radnje",
  "unavailable": "Nije dostupno, proširi za detalje"
}
